import { CardContent, IconButton, Typography, useTheme } from '@mui/material'
import { formatAmount } from '@src/services/Formatter'
import { CSSProperties, useState, FC, ReactNode } from 'react'
import { ShortCardStyled } from './StyledComponent'

interface ShortCardProps {
  title: string
  titleDate?: string
  value: string | number | null
  values?: (string | number | null)[]
  secondValue?: string | number | null
  additionalInfo?: string
  formatFunction?: (date: string) => string
  icon?: ReactNode
  amountValueClass?: string
  isMoney?: boolean 
  explenationDate?: string
}

const ShortCard: FC<ShortCardProps> = ({
  title,
  titleDate,
  value,
  values,
  secondValue,
  additionalInfo,
  formatFunction,
  icon,
  isMoney,
  explenationDate
}) => {
  const theme = useTheme()
  const [isVisible, setIsVisible] = useState(true); 

  const styles: Record<string, CSSProperties> = {
    typographyWeight200: {
      fontWeight: 200,
      fontSize: '1rem',
      color: theme.palette.text.primary,
    },
    typographyInfo: {
      fontWeight: 200,
      fontSize: '0.8rem',
      color: '#949494'
    },
    typographyLarge: {
      fontWeight: 200,
      fontSize: '1.6rem',
      marginBottom: '0.2rem',
    },
    typographyMedium: {
      fontWeight: 200,
      fontSize: '1.5rem',
    },
    money: {
      color: '#ffffff',
      fontSize: '2.5rem',
    },
    cents: {
      color: '#949494',
      fontSize: '2.5rem',
    },
    iconStyle : {
      marginLeft: 5,
      color: '#949494',
    }
  }
  const formatMoney = (amount: string) => {
    const { dollars, cents } = formatAmount(parseFloat(amount))
    return (
      <>
        <span style={styles.money}>{dollars}</span>
        <span style={styles.cents}>.{cents.padEnd(2, '0')}$</span>
      </>
    )
  }

  const renderValue = (item: string | number | null) => (
    <Typography style={styles.typographyLarge}>
      {isMoney && typeof item === 'string'
        ? formatMoney(item)
        : formatFunction
          ? formatFunction(String(item))
          : String(item) || 'Loading...'}
    </Typography>
  )

  const renderValues = (items: (string | number | null)[]) => items.map((item) => renderValue(item))
  const handleToggleVisibility = () => setIsVisible(!isVisible);

  return (
    <ShortCardStyled>
      <CardContent>
        <Typography style={styles.typographyWeight200}>
          {title}
        <IconButton style={styles.iconStyle} onClick={handleToggleVisibility}>{icon}</IconButton>
        </Typography>

        {isVisible ?  values ? renderValues(values) : renderValue(value) : ''}

        {additionalInfo && <Typography style={styles.typographyInfo}>{additionalInfo}</Typography>}

        {titleDate && secondValue && (
          <>
            <Typography style={styles.typographyWeight200}>{titleDate}</Typography>
            <Typography style={styles.typographyLarge}>
              {formatFunction ? formatFunction(String(secondValue)) : String(secondValue) || ''}
            </Typography>
            <Typography style={styles.typographyInfo}>{explenationDate}</Typography>
          </>
        )}
      </CardContent>
    </ShortCardStyled>
  )
}

export default ShortCard
